// @flow

import * as React from "react";
import Helmet from "react-helmet";
import queryString from "query-string";
import { parse } from "date-fns";
import { format } from "date-fns-tz";
import { useSelector } from "react-redux";
import _ from "lodash";

import { getAllPurchasedEvents, getProfile } from "../actions/user";
import usePageFromStore from "../hooks/usePageFromStore";
import Config from "../constants/Config";
import RelatedContent from "../components/organisms/RelatedContent";
import QuickRegistrationBody from "../components/organisms/QuickRegistrationBody";
import HeroEventDetail from "../components/organisms/HeroEventDetail";
import EventDetailBody from "../components/organisms/EventDetailBody";

import API from "../api/index";
import { useState } from "react";

type PropsType = {
    page: any,
};

const EventDetail = (props: PropsType): React.Node => {
    const queryParams = queryString.parse(document.location.search);
    const default_tile_image = useSelector(
        (state: any): any => state.options.default_tile_image
    );
    const [initialParams] = React.useState(queryParams);
    const { page, related } = usePageFromStore();
    const isProgramOfEvents =
        page && page.acf.linked_events && page.acf.linked_events.length
            ? true
            : false;

    // Hero EventDetail
    const hero = page.acf.hero;

    const categories = page.categories
        ? page.categories.map(category => category.term_id)
        : [];
    const renderSchemaData = () => {
        return JSON.stringify({
            startDate: format(
                parse(page.acf.start_date, "dd/MM/yyyy h:mm aa", new Date()),
                "yyyy-MM-dd'T'HH:mm:ssXXX",
                {
                    timeZone: "Australia/Sydney",
                }
            ),
            endDate: format(
                parse(page.acf.end_date, "dd/MM/yyyy h:mm aa", new Date()),
                "yyyy-MM-dd'T'HH:mm:ssXXX",
                {
                    timeZone: "Australia/Sydney",
                }
            ),
            name: page.post_title,
            url: page.url,
            image:
                page.acf.hero &&
                page.acf.hero.media &&
                page.acf.hero.media[0] &&
                page.acf.hero.media[0].image &&
                page.acf.hero.media[0].image.sizes.medium_large
                    ? page.acf.hero.media[0].image.sizes.medium_large
                    : default_tile_image.sizes.medium_large,
            eventStatus:
                page.acf.open_state === "cancelled"
                    ? "https://schema.org/EventCancelled"
                    : "https://schema.org/EventScheduled",
            location: {
                address: {
                    addressCountry: "",
                    addressLocality: "",
                    addressRegion: "",
                    streetAddress: page.event_location || "UTS",
                    postalCode: "",
                    "@type": "PostalAddress",
                    contactType: "customer service",
                },
                "@type": "Place",
                name: page.event_location,
            },
            eventAttendanceMode:
                "https://schema.org/OfflineEventAttendanceMode",
            "@context": "http://schema.org",
            // organizer: {
            //     url: "",
            //     "@type": "Organization",
            //     name: "",
            // },
            "@type": "Event",
            description: page.acf.excerpt,
        });
    };

    if (page.acf) {
        if (
            initialParams.quickRegistration === "true" &&
            initialParams.checkout === "success"
        ) {
            // club quick registration success page
            return <QuickRegistrationBody {...page} checkout={true} />;
        }

        return (
            <React.Fragment>
                <Helmet>
                    <script type="application/ld+json">
                        {renderSchemaData()}
                    </script>
                </Helmet>

                {hero ? (
                    <HeroEventDetail
                        {...hero}
                        title={page.post_title}
                        breadcrumbs={Config.eventBreadcrumbs}
                        location={page.event_location}
                        location_google_map_link={
                            page.acf.location_google_map_link
                        }
                        end_date={page.acf.end_date}
                        start_date={page.acf.start_date}
                        status={page.acf.open_state}
                        sold_out={page.acf.sold_out}
                        full_width={isProgramOfEvents}
                        parent_event={
                            page.acf.parent_event &&
                            page.acf.parent_event.post_status === "publish"
                                ? related[page.acf.parent_event.ID]
                                : null
                        }
                    />
                ) : null}

                <EventDetailBody
                    {...page}
                    isProgramOfEvents={isProgramOfEvents}
                />
            </React.Fragment>
        );
    } else {
        return null;
    }
};

EventDetail.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

EventDetail.preload = ({ passed: { store }, location }: any): Promise<any> => {
    return Promise.all([
        // store.dispatch(getProfile(true)),
        store.dispatch(getAllPurchasedEvents()),
    ]);
};

export default EventDetail;
